import React, { ChangeEvent, Dispatch, SetStateAction } from "react";
import { RiMailSettingsLine } from "react-icons/ri";
import { LanguageText } from "../../../../dictionary/GroupNotificationText";
import useGetLanguage from "../../../../utils/useGetLanguage";
import { MdOutlineError } from "react-icons/md";
import UserSelect from "./UserSelect";
import UsersList from "./UsersList";
import Recipients from "./Recipients";
import { Email as EmailType } from "../../../../features/notifications/notificationSlice";
import { ErrorType } from "../utils";
export interface NotificationEmailProps {
  isNew: boolean;
  email: EmailType;
  onEmailChange: Dispatch<SetStateAction<EmailType>>;
  onAddUser: (userID: string) => void;
  onRemoveUser: (userID: string) => void;
  groupID: string;
  groupMembers: any[];
  users: string[];
  usersError: boolean;
  emailError: ErrorType["email"];
}

const NotificationEmail = ({
  isNew,
  email: { subject, body, trigger },
  onEmailChange,
  onAddUser,
  onRemoveUser,
  groupID,
  groupMembers,
  users,
  usersError,
  emailError: { subject: subjectError, body: bodyError },
}: NotificationEmailProps): JSX.Element => {
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupNotificationText",
  });

  const handleEmailChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    onEmailChange((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  return (
    <div className="relative mb-6 bg-gray-100 rounded-lg shadow-sm border border-gray-200 mt-10 p-6 sm:p-8 lg:p-10 overflow-hidden transition-all duration-300">
      <RiMailSettingsLine
        size={20}
        className="absolute top-4 left-4 text-gray-500 hover:text-blue-500 transition-colors duration-200 cursor-pointer z-10"
      />
      <div className="flex flex-col w-full space-y-2 mt-8">
        <div className="flex flex-col space-y-4">
          {/* Recipients Option 1 */}
          {/* <UserSelect
            users={groupMembers}
            groupID={groupID || ""}
            onAddUser={onAddUser}
          />
          <UsersList users={users} removeUser={onRemoveUser} error={usersError} /> */}

          {/* Recipients Option 2 */}
          <Recipients
            isNew={isNew}
            members={groupMembers}
            users={users}
            removeUser={onRemoveUser}
            onAddUser={onAddUser}
            error={usersError}
          />
        </div>

        {/* Email subject */}
        <div className="w-full">
          <label className="block text-gray-700 font-medium mb-2 text-sm sm:text-base">
            {Language?.subject}
          </label>

          <input
            type="text"
            name="subject"
            value={subject ?? ""}
            className="border border-gray-300 rounded-md p-2 w-full text-sm sm:text-base bg-white focus:ring-2 focus:ring-blue-300 focus:border-blue-300 focus:outline-none transition-shadow duration-200"
            onChange={handleEmailChange}
          />

          {subjectError && (
            <div className="flex items-center mt-2 text-red-500">
              <MdOutlineError className="text-lg mr-2 flex-shrink-0" />
              <span className="text-xs sm:text-sm">{Language?.subjectErrorMsg}</span>
            </div>
          )}
        </div>

        {/* Email message */}
        <div className="w-full">
          <label className="block text-gray-700 font-medium mb-2 text-sm sm:text-base">
            {Language?.message}
          </label>

          <textarea
            className="border border-gray-300 rounded-md p-2 w-full h-28 sm:h-32 resize-none text-sm sm:text-base bg-white focus:ring-2 focus:ring-blue-300 focus:border-blue-300 focus:outline-none transition-shadow duration-200"
            name="body"
            value={body ?? ""}
            onChange={handleEmailChange}
          />

          {bodyError && (
            <div className="flex items-center mt-2 text-red-500">
              <MdOutlineError className="text-lg mr-2 flex-shrink-0" />
              <span className="text-xs sm:text-sm">{Language?.messageErrorMsg}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationEmail;
